var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubtraction3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 376,
    height: 190.5,
    viewBox: "0 0 376 190.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-2928.5,203.5h-327a23.843,23.843,0,0,1-16.971-7.029,23.844,23.844,0,0,1-7.03-16.971V32.815a175.656,175.656,0,0,1,28.488-10.243,237.331,237.331,0,0,1,28.168-5.945A241.712,241.712,0,0,1-3187.4,14a240.053,240.053,0,0,1,93.56,19.061,242.708,242.708,0,0,0,94.644,19.051c6.337,0,12.784-.244,19.16-.724,41.234-3.107,70.154-15.481,75.533-17.93V179.5a23.844,23.844,0,0,1-7.03,16.971A23.843,23.843,0,0,1-2928.5,203.5Z",
    transform: "translate(3280 -13.5)",
    fill: "#16c389",
    stroke: "#707070",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtraction3);
export default __webpack_public_path__ + "static/media/Subtraction 3.1fe53a07f323b60b85df56a7f7bb2eb4.svg";
export { ForwardRef as ReactComponent };